import { apiClient } from './client'
import type {
  CreateAdminUserInput,
  UpdateAdminUserInput,
  AdminUserListResponse,
  AdminUserResponse,
  CreateAdminUserResponse,
} from '@/types/admin-user'

export const adminUsersApi = {
  /**
   * List all admin users
   */
  getAdminUsers: async (params?: {
    limit?: number
    paginationToken?: string
    role?: string
    search?: string
  }): Promise<AdminUserListResponse> => {
    const response = await apiClient.get<AdminUserListResponse>('/admin-users', { params })
    return response.data
  },

  /**
   * Get single admin user by email
   */
  getAdminUser: async (email: string): Promise<AdminUserResponse> => {
    const response = await apiClient.get<AdminUserResponse>(`/admin-users/${email}`)
    return response.data
  },

  /**
   * Create new admin user
   */
  createAdminUser: async (data: CreateAdminUserInput): Promise<CreateAdminUserResponse> => {
    const response = await apiClient.post<CreateAdminUserResponse>('/admin-users', data)
    return response.data
  },

  /**
   * Update admin user
   */
  updateAdminUser: async (
    email: string,
    data: UpdateAdminUserInput
  ): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.patch(`/admin-users/${email}`, data)
    return response.data
  },

  /**
   * Delete admin user
   */
  deleteAdminUser: async (email: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.delete(`/admin-users/${email}`)
    return response.data
  },

  /**
   * Reset user password (sends reset email)
   */
  resetPassword: async (email: string): Promise<{ success: boolean; message: string }> => {
    const response = await apiClient.post(`/admin-users/${email}/reset-password`)
    return response.data
  },
}
